import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, HostListener, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {GetAndSetCartDataInLocalstorageService} from 'src/app/cart/service/set-cart-data-in-localstorage.service';
import {FabricProfileItemList} from 'src/app/product-details/interface/fabric-profile-item-list';
import {MadeToOrderFabric} from 'src/app/product-details/interface/made-to-order-fabric';
import {Product} from 'src/app/product-details/interface/product';
import {VolumeDiscountProfile} from 'src/app/product-details/interface/volume-discount-profile';
import {FilterFabricProfileService} from 'src/app/product-details/service/filter-fabric-profile.service';
import {PrepareInstockCalculationService} from 'src/app/product-details/service/prepare-instock-calculation.service';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {QuantityCalculationService} from 'src/app/product-details/service/quantity-calculation.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
	selector: 'fb-choose-fabric',
	templateUrl: './choose-fabric.component.html',
	styleUrls: ['./choose-fabric.component.scss']
})
export class ChooseFabricComponent {
	constructor(
		private _quantiCalculation: QuantityCalculationService,
		private _priceCalculation: PriceCalculationService,
		private _globalService: GlobalService,
		private _cartCalculation: CartCalculationService,
		private _prepareItemInStockCalculation: PrepareInstockCalculationService,
		private _getCartDataInLocal: GetAndSetCartDataInLocalstorageService,
		private _filterFabricProfile: FilterFabricProfileService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	 }

	@Input() fabricData: Product = {} as Product;
	@Output() imageTransferDisplayImage: EventEmitter<string> = new EventEmitter<string>();

	public fabricProfile: FabricProfileItemList[] = [];
	public madeToOrderFabric: MadeToOrderFabric = {} as MadeToOrderFabric;
	public showMore: boolean = false;
	public previousDeltaIndex : number= 0;
	public deltaIndex: number = 0;
	public deltaIndexForMoreInfo: number = -1;
	public fabricProfileMoreThan7: FabricProfileItemList[] = [];
	public copySelectedSizeQuan: number = 0;
	public isBrowser: boolean = false;
	public selectedFabricName: string = '';

	public showFabricMoreOption(): void {
		this.showMore = true;
		this._globalService.popUpOpenClose(true);
	}

	public closeFabricMoreOption(): void {

		this.showMore = false;
		this._globalService.popUpOpenClose(false);
		// this.deltaIndex = 0;
		// this.selectFabricOption(0, this.madeToOrderFabric, null, this.madeToOrderFabric.heroImage)
	}



	public fromSelectFabricOption(i: number, evt: FabricProfileItemList): void {
		this.selectFabricOption(i, null, evt, evt.mockupImage)
	}



	public selectFabricOption(
		i: number,
		madeToOrder: MadeToOrderFabric | null,
		FabProfile: FabricProfileItemList | null,
		url: string
	): void {

		this._priceCalculation.productQuantity = 0;
		console.log(i, madeToOrder, FabProfile, url)

		if (madeToOrder) {

			this._cartCalculation.orderType = "IN_STOCK";
			this._cartCalculation.selectedFabricProfileItemId = madeToOrder.id;

			this._globalService.isTheOrderInstock.next(true);
		}
		else {
			this._cartCalculation.orderType = "MADE_TO_ORDER";
			this._cartCalculation.selectedFabricProfileItemId = FabProfile?.fabricPreview.id!
			this._globalService.isTheOrderInstock.next(false);
		}
		this.deltaIndex = i;
		this.previousDeltaIndex = i;

		if (i != 0) this.imageTransferDisplayImage.emit(url)
		else this.imageTransferDisplayImage.emit('');

		if (i == 0) {  //MTO

			this._quantiCalculation.MTOselected = true;
			this._quantiCalculation.selectedAvailableSizeQuantity = this._quantiCalculation.copySelectedSizeQuantityValidOnly;
			setTimeout(() => this._quantiCalculation.UpdateQuantityFabric(true), 0);
			this._cartCalculation.selectedFabricItem = madeToOrder!;

		}
		else { // not MTO
			this._quantiCalculation.selectedFabricQuantity = FabProfile!.fabricPreview.totalQuantity;
			this._quantiCalculation.selectedAvailableSizeQuantity = 0;
			this._quantiCalculation.MTOselected = false;
			setTimeout(() => this._quantiCalculation.UpdateQuantityFabric(false), 0);
			this._cartCalculation.selectedFabricItem = FabProfile?.fabricPreview!;

		}


		if (i == 0) {  //MTO

			this._prepareItemInStockCalculation.isSelectedFabricMTOF = true;
			this._prepareItemInStockCalculation.fabricQTY = madeToOrder?madeToOrder.totalQuantity:0;
		}
		else{

			this._prepareItemInStockCalculation.isSelectedFabricMTOF = false;
			this._prepareItemInStockCalculation.fabricQTY = FabProfile?FabProfile.fabricPreview.totalQuantity:0;
		}

		this._prepareItemInStockCalculation.returnResultInsockQuantity$.next(true);



		//price calculation start


		if (i === 0) {  //MTO
			// debugger
			this.selectedFabricName = this.madeToOrderFabric.name;
			this._priceCalculation.selectedFabricPrice = (madeToOrder?.price) ? (madeToOrder?.price) : 0;
			this._cartCalculation.orderType = 'IN_STOCK';
			this._prepareItemInStockCalculation.isSelectedFabricInStock = true;

			this._priceCalculation.selectedFabricVolumeDiscountProfile = madeToOrder?.volumeDiscountProfile?madeToOrder.volumeDiscountProfile: {} as VolumeDiscountProfile;

			this._priceCalculation.isSelectedFabricInStock = true;


			if(this.fabricData.totalQuantity){

				this._cartCalculation.orderType = "IN_STOCK";
				this._priceCalculation.isSelectedFabricInStock = true;
				this._globalService.isTheOrderInstock.next(true);

			}
			else {
				this._cartCalculation.orderType = 'MADE_TO_ORDER';
				this._priceCalculation.isSelectedFabricInStock = false;
				this._globalService.isTheOrderInstock.next(false);
			}




			setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'choose-fabric'), 0);



		}
		else { // not MTO
			this.selectedFabricName = FabProfile?.fabricPreview.name || '';
			this._priceCalculation.selectedFabricPrice =
				(FabProfile?.fabricPreview.price) ? (FabProfile?.fabricPreview.price) : 0;
				this._cartCalculation.orderType = 'MADE_TO_ORDER';
				this._prepareItemInStockCalculation.isSelectedFabricInStock = false;

				this._priceCalculation.selectedFabricVolumeDiscountProfile = FabProfile?.fabricPreview.volumeDiscountProfile?FabProfile.fabricPreview.volumeDiscountProfile: {} as VolumeDiscountProfile;

				this._priceCalculation.isSelectedFabricInStock = false;

			setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'choose-fabric'), 0)
		}

		this.gotoImageLocationWhenClickOnFabric();
		this.deltaIndexForMoreInfo = -1;

	}

	public gotoImageLocationWhenClickOnFabric(): void {

		let isMobile:boolean = false;
		if (this.isBrowser)
			isMobile = window.innerWidth < 999;
		setTimeout(() => {

			// TODO: do not remove the code below
			// let section: HTMLElement | null = document.getElementById('img_jump_to_fabric');
			// if (section !== null) {
			// 	section.scrollIntoView({
			// 		behavior: 'smooth'
			// 	});
			// 	section = null;
			// }
			// TODO: do not remove the code above
			if (this.isBrowser)
				window.scrollTo(0, 0);

		}, isMobile ? 100 : 0)
	}

	public ngOnInit(): void {

		this.copySelectedSizeQuan = this._quantiCalculation.copySelectedSizeQuantityValidOnly;

		this._cartCalculation.selectedFabricProfileItemId =
		this.fabricData.madeToOrderFabric ? this.fabricData.madeToOrderFabric!.id
		: this.fabricData.fabricProfile!.fabricProfileItemList[0].id;

		let fabricProfileItemList: FabricProfileItemList[] = this.fabricData.fabricProfile!.fabricProfileItemList || [];

		fabricProfileItemList = this._filterFabricProfile.filterFabricBasedOnMTOProfileConsumption(fabricProfileItemList ,this.fabricData);


		fabricProfileItemList.forEach((elm: FabricProfileItemList, i: number) => {
			if (i <= 2) {
				this.fabricProfile.push(elm)
			}
			if (i >= 3) {
				this.fabricProfileMoreThan7.push(elm)
			}
		});

		this.madeToOrderFabric = this.fabricData.madeToOrderFabric ? this.fabricData.madeToOrderFabric : {} as MadeToOrderFabric;

		this._prepareItemInStockCalculation.isSelectedFabricMTOF = true;
			this._prepareItemInStockCalculation.fabricQTY = this.madeToOrderFabric.id ?this.madeToOrderFabric.totalQuantity:0;

		this._priceCalculation.selectedFabricPrice = (this.madeToOrderFabric?.price) ? (this.madeToOrderFabric?.price) : this.fabricProfile[0].fabricPreview.price;

		this._priceCalculation.selectedFabricVolumeDiscountProfile = this.fabricData.volumeDiscountProfile && this.fabricData.volumeDiscountProfileEnabled?this.fabricData.volumeDiscountProfile: {} as VolumeDiscountProfile;




		setTimeout(() => this._priceCalculation.calculatePrice(false, true, 'choose-fabric'), 0);

		setTimeout(() => this._byDefaultSelectedFabric(), 0);


		this._getCartDataInLocal.openCartModal.subscribe((isOpen:boolean): void=>{

			if(!isOpen) {
				this.selectFabricOption(0, this.madeToOrderFabric, null, this.madeToOrderFabric.heroImage)
			}
		});

		this.selectedFabricName = this.madeToOrderFabric.name||'';



	}

	public moreFabricInfo(i: number): void {
		// this.deltaIndex = i;
		this.deltaIndexForMoreInfo = i;
		// this.closeInfo = true;
	}
	public moreFabricInfoRemove(e: any): void {
		// this.deltaIndex = this.previousDeltaIndex - 1;
		this.deltaIndexForMoreInfo = -1;
		// this.closeInfo = false;
		e.stopPropagation()
	}

	public continueMoreClick(data: FabricProfileItemList): void {

		this.deltaIndex = -5;
		this.previousDeltaIndex = this.deltaIndex;
		this.showMore = false;

		this._globalService.popUpOpenClose(false);

		this._selectedFabricFromMoreOption(data);
	}

	public continueClickWithMTOSelected(): void {

		this.deltaIndex = 0;
		this.previousDeltaIndex = this.deltaIndex;
		this.showMore = false;

		this._globalService.popUpOpenClose(false);

		this._byDefaultSelectedFabric();
	}

	private _byDefaultSelectedFabric(): void {
		this.selectFabricOption(0,this.madeToOrderFabric,null, this.madeToOrderFabric.heroImage)
	}

	private _selectedFabricFromMoreOption(
		selectedFabricItemFromPopup: FabricProfileItemList,
		MadeToOrderFabric? : MadeToOrderFabric
		): void {

		if(MadeToOrderFabric?.id && MadeToOrderFabric.id === this.madeToOrderFabric.id){
			this.deltaIndex = 0;
			this.previousDeltaIndex = 0;
			return;
		}

		this.fabricData.fabricProfile!.fabricProfileItemList.forEach(
			( fabricItem:FabricProfileItemList , i: number): void=>{

			if(fabricItem.fabricPreview.name === selectedFabricItemFromPopup.fabricPreview.name){

				this.deltaIndex = i+1;
				this.previousDeltaIndex = i+1;

				if( i >= ( this.fabricProfile.length-1) ){
					// when click from fabric profile popup

					this.fabricProfile[3] = selectedFabricItemFromPopup;
					this.deltaIndex = 4;
				}
			}
		});
	}


	@HostListener('document:click', ['$event'])
	public clickOut():void {
	this.deltaIndexForMoreInfo = -1;
	}
}
